/** The "upgrade to Premium Plus" trigger is authored inside the heading lang strings the callers pass in. */
export const UPGRADE_FOR_CREDITS_TRIGGER_SELECTOR = '.js-upgrade-for-credits';
